// extracted by mini-css-extract-plugin
export default {"previewCard":"PreviewCard_previewCard__VqqZ2","activePreviewCard":"PreviewCard_activePreviewCard__DL2b4","endpapercard":"PreviewCard_endpapercard__JIO07"};